import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';
import { useSMLCountryParam } from './useSMLCountryParam';

interface UseTrackPositionChangeProps {
  trackId: string;
  date?: Date;
  rangeDays?: number;
}

export const useTrackPositionChange = ({ trackId, date, rangeDays }: UseTrackPositionChangeProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  const { countryCode } = useSMLCountryParam();

  const positionChangeQuery = useTRPCQuery(
    trpcMusicAPI.tracks.positionChange.queryOptions({
      trackId,
      date,
      rangeDays,
      // Public share links pin the global view.
      countryCode: shareTokenInput.shareToken !== undefined ? undefined : countryCode,
      ...shareTokenInput,
    })
  );

  return positionChangeQuery;
};
